module.exports = __webpack_public_path__ + "img/qingse.d3162918.png";